var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#FF4B55"
    },
    width: 512,
    height: 512
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M257.529,121.263c74.359,0,134.629,60.433,134.629,134.737c0,74.519-60.27,134.737-134.629,134.737  c-74.519,0-134.844-60.218-134.844-134.737C122.685,181.696,183.01,121.263,257.529,121.263"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M282.012,331.502c-41.71,0-75.542-33.831-75.542-75.493c0-41.561,33.832-75.392,75.542-75.392   c14.187,0,27.444,3.975,38.776,10.839c1.698,1.028,3.483-1.195,2.069-2.588c-17-16.749-40.278-27.125-65.992-27.125   c-52.201,0-94.467,42.266-94.467,94.266c0,52.1,42.266,94.365,94.467,94.365c25.7,0,48.968-10.366,65.965-27.112   c1.414-1.393-0.371-3.616-2.069-2.588C309.436,327.533,296.189,331.502,282.012,331.502z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF4B55"
    },
    d: "M275.11,203.169l20.825,28.276l33.495-10.55c4.336-1.366,7.916,3.574,5.268,7.27l-20.457,28.543   l20.384,28.595c2.639,3.702-0.953,8.633-5.286,7.256l-33.468-10.635l-20.897,28.223c-2.705,3.654-8.505,1.761-8.535-2.785   l-0.227-35.116l-33.299-11.153c-4.311-1.444-4.303-7.545,0.011-8.977l33.327-11.068l0.317-35.116   C266.609,201.386,272.414,199.509,275.11,203.169z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", null)), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTn);
export default __webpack_public_path__ + "static/media/tn.0796c3175b864893af6db2d8175092ef.svg";
export { ForwardRef as ReactComponent };